// src/firebase/config.ts
import { initializeApp, getApp, getApps } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getStorage } from "firebase/storage"; // ✅ add this

// ---- Your Web App config ----
export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Reuse the app if it already exists (avoids duplicate init during HMR)
export const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

// Auth: persist sessions in the browser
export const auth = getAuth(app);
setPersistence(auth, browserLocalPersistence).catch(() => {
  // non-fatal in Safari private mode, etc.
});

// Firestore — with offline persistence so subsequent reads are instant
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
});

// Cloud Functions — EU region
export const functions = getFunctions(app, "europe-west2");

// Connect to local emulator in development
if (import.meta.env.DEV) {
  connectFunctionsEmulator(functions, "localhost", 5002);
}

// ✅ NEW: Storage
export const storage = getStorage(app);

// Optional default export
export default app;
